import React from "react";

export interface ChartCardProps {
  title: string;
  subtitle?: string;
  actions?: React.ReactNode;
  /** Fixed body height in px for chart canvases. */
  height?: number;
  className?: string;
  children: React.ReactNode;
}

export const ChartCard: React.FC<ChartCardProps> = ({
  title,
  subtitle,
  actions,
  height,
  className = "",
  children,
}) => {
  return (
    <div className={`an-card ${className}`}>
      <div className="an-card-header">
        <div>
          <h3 className="an-card-title">{title}</h3>
          {subtitle && <p className="an-card-subtitle">{subtitle}</p>}
        </div>
        {actions && <div className="an-card-actions">{actions}</div>}
      </div>
      <div className="an-chart-body" style={height ? { height } : undefined}>
        {children}
      </div>
    </div>
  );
};

export default ChartCard;
